/** The dial for a period without a score: the same ring, empty, saying why. */
export function NoScoreRing({ reason, size = 'sm' }: { reason: string; size?: 'lg' | 'sm' }) {
  const box = size === 'lg' ? 'w-24 h-24' : 'w-16 h-16'
  return (
    <div className={`relative ${box} mx-auto`}>
      <svg viewBox="0 0 90 90" className={box}>
        <circle cx="45" cy="45" r="36" fill="none" stroke="rgba(12,94,116,0.1)" strokeWidth="8" />
      </svg>
      <div className="absolute inset-0 flex flex-col items-center justify-center">
        <div className={`${size === 'lg' ? 'text-2xl' : 'text-lg'} font-black text-ink-mid`}>–</div>
        <div className="text-[8px] font-bold uppercase tracking-wide text-ink-mid text-center leading-tight">{reason}</div>
      </div>
    </div>
  )
}
